import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { apiErrorMessage, quoteValidationError, trimFields } from "@/lib/formHelpers";

const EMPTY = { request_type: "devis", service: "autre", name: "", contact: "", message: "", depart: "", arrivee: "", date_trajet: "" };

export const useQuoteForm = ({ open, service, prefillMessage, onClose, onSent }) => {
  const [fields, setFields] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const serviceId = service?.id || "autre";
  const requestType = service?.requestType || "devis";
  useEffect(() => {
    if (open) setFields((current) => ({ ...current, service: serviceId, request_type: requestType, message: prefillMessage || "" }));
  }, [open, serviceId, requestType, prefillMessage]);
  const update = (name, value) => setFields((current) => ({ ...current, [name]: value }));
  const submit = async (event) => {
    event.preventDefault();
    const payload = trimFields(fields);
    const validationError = quoteValidationError(payload);
    if (validationError) { toast.error(validationError); return; }
    setSending(true);
    try {
      await axios.post(`${API}/requests`, payload);
      toast.success("Demande envoyée ! Je te réponds très vite.");
      setFields(EMPTY);
      onClose();
      onSent?.();
    } catch (err) {
      toast.error(apiErrorMessage(err, "Envoi impossible pour le moment, réessaie"));
    } finally { setSending(false); }
  };
  return { fields, update, sending, submit };
};